<div class="map-wrapper">
    <div id="map" class="map-body">
    </div>
</div>